module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","exam":"Prüfung"},"en":{"cancel":"Cancel","exam":"Exam"}}')
  delete Component.options._Ctor
}
